import AdminLayout from '@/views/adminLayout/AdminLayout'
import store from '../store'

export function beforeFun(to, from, next) {
  const hasLogin = store.getters.hasLogin
  const level = store.state.user.userInfo.level
  if (to.name === 'homePage') { // 首页不做处理
    next()
  } else if (to.path.includes('/admin') && (!hasLogin || level < 100)) { // 未登录或者无权限的不能进入管理员页面
    next({ name: 'homePage' })
  } else {
    next()
  }
}

export default [
  {
    path: '/admin',
    component: AdminLayout,
    name: 'adminPage',
    meta: { title: '系统管理' },
    redirect: '/admin/user',
    beforeEnter: beforeFun,
    isShow() {
      return false
    },
    children: [
      {
        path: 'user',
        name: 'userList',
        isShow() {
          return true
        },
        component: () => import(/* webpackChunkName: "userManager" */ '@/views/user/list'),
        meta: { title: '用户管理' }
      },
      {
        path: 'group',
        name: 'userGroupList',
        isShow() {
          return true
        },
        component: () => import(/* webpackChunkName: "userGroupManager" */ '@/views/userGroup/list'),
        meta: { title: '用户组管理' }
      },
      {
        path: 'markdown',
        name: 'markdownList',
        isShow() {
          return true
        },
        component: () => import(/* webpackChunkName: "markdownManager" */ '@/views/markdown/list'),
        meta: { title: 'markdown文档管理' }
      }
    ]
  }
]
